export default __webpack_public_path__ + "static/media/safe-part.f3899554.svg";